import React from "react";
import {
    questionsGet as fetchMessages,
    eventQuestionCreate as createMessage,
    questionLikeToggle as likeMessage,
} from "api";
import Comment from "./comment";

export default class extends Comment {
    get name() {
        return 'question';
    }

    get roomsKeys () {
        return this.$app.event().stream().map(stream => stream.questionRoom.roomKey())
    }

    fetchMessages(params) {
        return fetchMessages(this.eventKey, {...params, roomsKeys: this.roomsKeys});
    }

    createMessage(data) {
        return createMessage(this.eventKey, data);
    }

    likeMessage(id, like) {
        return likeMessage(this.eventKey, id, like);
    }

    sortMessages(a, b) {
        if (a.fixed !== b.fixed) {
            return b.fixed - a.fixed;
        }
        if (a.likes !== b.likes) {
            return b.likes - a.likes;
        }
        return b.time - a.time;
    }

    sortChildren(a, b) {
        return this.sortMessages(a, b);
    };

}
